import {useSelector} from 'react-redux';
import {isEmpty, isLoaded} from 'react-redux-firebase';
import {RootReducerType} from '../../../types/Reducers.d';
import {Profile} from '../../../types/User.d';

/**
 * Return auth is logged
 */
const useAuth = (): [boolean, Profile|any, any] => {
  const auth = useSelector((state: RootReducerType) => state.firebase.auth);
  const profile = useSelector((state: RootReducerType) => state.firebase.profile);
  return [
    (isLoaded(auth) && !isEmpty(auth)),
    profile,
    auth
  ];
};

export default useAuth;
